<script lang="ts" setup>
import { useI18n } from 'vue-i18n';

import { useStatsigEventsStore } from '@apps/main/new-desktop/core/stores';

import type { TransportType } from '@libs/trip-planner-interfaces';

import { TransportSelector } from '../../../../modules/tranposrtSelector';

const { t } = useI18n();

interface ItineraryTransportSelectorProps {
  transportType: TransportType;
  disabled: boolean;
  hasUserSelectedTransport?: boolean;
  isUpsellNoTransport?: boolean;
}
const props = defineProps<ItineraryTransportSelectorProps>();

interface ItineraryTransportSelectorEmits {
  (eventName: 'select-transport', value: TransportType): void;
}
const emit = defineEmits<ItineraryTransportSelectorEmits>();

const statsigEventsStore = useStatsigEventsStore();
</script>

<template>
  <div class="itinerary-transport-selector">
    <TransportSelector
      :transport-type="props.transportType"
      :disabled="props.disabled"
      :initial-option="
        props.hasUserSelectedTransport
          ? t('planner.transport.no_transport_selected')
          : t('planner.transport.add_transport')
      "
      :has-user-selected-transport="props.hasUserSelectedTransport"
      :is-upsell-no-transport="props.isUpsellNoTransport"
      @select="emit('select-transport', $event)"
      @open="statsigEventsStore.logTripOverviewTransportSelectorOpened"
    />
  </div>
</template>
